module.exports = __webpack_public_path__ + "static/media/bags-shopping.3ab0f287.svg";